<template>
  <v-dialog v-model="show" class="modal" persistent max-width="739px" scrollable>
    <v-card
      style="align-items: baseline; overflow-y: auto; padding: 32px 32px; gap: 2.5rem"
      :class="[{ 'sport-organization-modal-container': isSportOrganization() }]"
    >
      <div class="header">
        <h1 :class="[{ 'sport-organization-title': isSportOrganization() }]">Prijavi se ovdje</h1>
        <v-icon
          style="cursor: pointer; user-select: none"
          :style="isSportOrganization() && 'color: white'"
          @click="$emit('close')"
        >
          close
        </v-icon>
      </div>
      <div style="width: 100%">
        <text-field
          v-model.trim="form.email"
          :validator="$v.form.email"
          type="email"
          label="Unesi email*"
        />
        <text-field
          v-model.trim="form.password"
          :validator="$v.form.password"
          type="password"
          label="Unesi lozinku*"
        />
      </div>
      <div style="display: flex; justify-content: flex-end; width: 100%">
        <main-button flat color="#333" style="border-radius: 0; display: none">
          zaboravljena lozinka?
        </main-button>
        <main-button
          :style="isSportOrganization() ? 'color: #0054A5' : 'border-radius: 0'"
          :color="isSportOrganization() ? 'white' : '#333'"
          @click="submitForm"
        >
          prijavi se
        </main-button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, email, minLength } from 'vuelidate/lib/validators'
import { submitGuard } from '../../../../../utils'
import { LOGIN } from '@/graphql/auth.graphql'
import { OrganizationType } from '@/types'

export default {
  name: 'login-modal',
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    organizationType: String,
  },
  validations() {
    return {
      form: {
        email: { required, email },
        password: { required, minLength: minLength(8) },
      },
    }
  },
  data() {
    return {
      form: {},
    }
  },

  methods: {
    async submitForm() {
      await submitGuard(this, async () => {
        const { errors } = await this.$apollo.mutate({
          mutation: LOGIN,
          variables: this.form,
        })
        if (errors) {
          this.snackbar = {
            open: true,
            messageProp: errors[0].message,
            color: 'error',
          }
        } else {
          this.$v.$reset()
          this.$emit('refetchUser')
        }
      })
    },
    handleForgotPassword() {
      let routeData = this.$router.resolve({ name: this.routes.shared.forgotPassword })
      window.open(routeData.href, '_blank')
    },
    isSportOrganization() {
      return this.organizationType === OrganizationType.SPORT_ORGANIZATION
    },
  },
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
h1 {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 24px;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 28.8px */
  letter-spacing: -0.72px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.sport-organization-modal-container {
  background-color: #0054a5;
}
.sport-organization-title {
  color: #fff;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.72px;
}
</style>
